export type WidthLayoutMod = 'w20' | 'w25' | 'w33' | 'w50' | 'w_auto' | 'doorType_w16'| 'doorType_w33';

export type ImageLayoutMod = 'hasIcon' | 'searchIcon';

export type InputMod = 'narrow' | 'wide' | 'password';

export type CheckboxMod = 'box' | 'small' | 'toggle';

export type RadioMod = 'stitched' | 'doorType';

export type ButtonDropdownLayoutMod = 'form' | 'form_sm' | 'table' | 'label';

export type TableLayoutMod = 'wide' | 'narrow' | 'dashboard';

export type UploadPhotoMod = 'circle' | 'square' | 'rectangle';

export type ImportStatusMod = 'uploading' | 'success' | 'error' | 'partial';

export type SizeMod = 'size_xxxs' | 'size_xxs' | 'size_xs' | 'size_sm' | 'size_lg';

export type AlignMod = 'centered';

export type SelectDropdownPositionMod = 'top' | 'bottom' | 'auto';

export type ModifierTypes = WidthLayoutMod | ImageLayoutMod | InputMod | CheckboxMod | AlignMod |
  ButtonDropdownLayoutMod | TableLayoutMod | RadioMod | UploadPhotoMod | SizeMod | ImportStatusMod;

export enum MenuDirectionMod {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  RIGHT = 'RIGHT'
}

export enum MassActionsMod {
  MiniCart = 'MiniCart',
  MassOperations = 'MassOperations',
  Base = 'Base'
}

export enum SvgIconSizeMod {
  DEFAULT = '18',
  EXTRA_SMALL = '14',
  SMALL = '16',
  MEDIUM = '20',
  LARGE = '24'
}

export type PopoverSizeTypes = 'base' | 'small';

export type FormsFieldsState = 'error' | 'required' | 'updated' | 'new';
